import React, { Fragment, useState } from 'react';
import { Image, Map, Settings, Target, VideoOff } from 'react-feather';
import { Nav, NavLink, NavItem } from 'reactstrap';
import i18n from '../../../../i18n';

const SearchTabs = ({ callbackActive }) => {
  const [activeTab, setActiveTab] = useState('1');
  return (
    <Fragment>
      <Nav tabs className="search-list" id="top-tab" role="tablist">
        <NavItem><NavLink className={activeTab === '1' ? 'active' : ''} onClick={() => {
          setActiveTab('1'); callbackActive('1');
        }}><Target className="icon-target" />&nbsp;Avis</NavLink>
          <div className="material-border"></div>
        </NavItem>
        <NavItem><NavLink className={activeTab === '2' ? 'active' : ''} onClick={() => {
          setActiveTab('2'); callbackActive('2');
        }}><Target className="icon-target" />&nbsp;{i18n.t('Dashboard_SearchResults_Users')}</NavLink>
          <div className="material-border"></div>
        </NavItem>
        <NavItem><NavLink className={activeTab === '3' ? 'active' : ''} onClick={() => {
          setActiveTab('3'); callbackActive('3');
        }}><Target className="icon-target" />&nbsp;{i18n.t('Dashboard_SearchResults_Clients')}</NavLink>
          <div className="material-border"></div>
        </NavItem>
        <NavItem><NavLink className={activeTab === '2' ? 'active' : ''} onClick={() => {
          setActiveTab('2'); callbackActive('2');
        }}><Image className="icon-image" />&nbsp;{i18n.t('Dashboard_SearchResults_Images')}</NavLink>
          <div className="material-border"></div>
        </NavItem>
        <NavItem><NavLink className={activeTab === '3' ? 'active' : ''} onClick={() => {
          setActiveTab('3'); callbackActive('3');
        }}><VideoOff className="icon-video-clapper" />&nbsp;{i18n.t('Dashboard_SearchResults_Videos')}</NavLink>
          <div className="material-border"></div>
        </NavItem>
        <NavItem><NavLink className={activeTab === '4' ? 'active' : ''}><Map className="icon-map-alt" />&nbsp;{i18n.t('Dashboard_SearchResults_Maps')}</NavLink>
          <div className="material-border"></div>
        </NavItem>
        <NavItem><NavLink className={activeTab === '5' ? 'active' : ''} ><Settings className="icon-settings" />&nbsp;{i18n.t('Dashboard_SearchResults_Settings')}</NavLink>
          <div className="material-border"></div>
        </NavItem>
      </Nav>
    </Fragment>
  );
};
export default SearchTabs;
